import { render, staticRenderFns } from "./FormInputGroupButton.vue?vue&type=template&id=ef3d883e&"
import script from "./FormInputGroupButton.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports